
<template>
  <HomepageLandingLayout :keywords="keywords" :description="description">
    <LandingPageHero :headline="headline" :subtitle="subtitle"/>
    <LandingPageSaveTime />
    <LandingPagePortal />
    <Testimonial />
    <Demo />
  </HomepageLandingLayout>
</template>

<script>
export default {
  props: [
    'keywords', 'description', 'headline', 'subtitle'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/LandingPage.vue